import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function IsRegisteredCheckbox() {
  return (
    <Field type="checkbox" name="isRegistered" label={i18n.t('entity.vehicle.labels.registered')} />
  );
}
